/* eslint-disable @typescript-eslint/no-require-imports */
import { Platform } from 'react-native';

const AboutScreen =
  Platform.OS === 'web' ? require('./about.web').default : require('./about.native').default;

export default AboutScreen;
